import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isLoggedIn(): boolean {
    if (!this.isBrowser) return false;

    // Check BOTH stores — covers whichever the login widget used.
    const store = this.readAuthData();
    if (!store) return false;

    const expiry = Number(localStorage.getItem('authExpiry') ?? sessionStorage.getItem('authExpiry'));
    if (expiry && Date.now() > expiry) return false;

    return !!store?.UserID;
  }

  private readAuthData(): any {
    for (const storage of [localStorage, sessionStorage]) {
      try {
        const raw = storage.getItem('authData');
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed?.UserID) return parsed;
        }
      } catch { /* ignore */ }
    }
    return null;
  }
}